<template>
	<div>
        <div class="img-color-overlay">
            <div class="container">
              <div class="row section-separator">
                <div class="each-quates col-sm-12 col-md-6">
                    <h3 class="wow fadeInUp" data-wow-duration="0.8s" data-wow-delay="0.2s" style="visibility: hidden; animation-duration: 0.8s; animation-delay: 0.2s; animation-name: none;">
                        {{ $t('quates.interestedToWork') }}
                    </h3>
                    <p class="wow fadeInUp" data-wow-duration="0.8s" data-wow-delay="0.4s" style="visibility: hidden; animation-duration: 0.8s; animation-delay: 0.4s; animation-name: none;">
                        {{ $t('quates.description') }}
                    </p>
                    <a href="#mh-contact" class="btn btn-fill wow fadeInUp" data-wow-duration="0.8s" data-wow-delay="0.5s" style="visibility: hidden; animation-duration: 0.8s; animation-delay: 0.5s; animation-name: none;">
                        {{ $t('quates.contact') }}
                    </a>
                </div>
              </div>
            </div>
        </div>
	</div>
</template>
<script>
export default {
    data(){
        return {

        }
    },
    components: {  },
    created(){

    },
    mounted(){

    },
    computed: {

    },
    watch:{

    },
    methods: {

    }
}
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Quates.vue